import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ColorlibConnector from "../../components/DashboardSidebar/customConnector";
import { Box, Stepper, Step, StepLabel } from "@mui/material";
import RegFirstStep from "./RegFirstStep/RegFirstStep";
import RegSecondStep from "./RegSecondStep/RegSecondStep";
import RegThirdStep from "./RegThirdStep/RegThirdStep";
import RegFourthStep from "./RegFourthStep/RegFourthStep";
import BankAccountVerify from "./BankAccountVerify/BankAccountVerify";
import "./Register.scss";
import { useSelector } from "react-redux";

const Register = () => {
  const { t } = useTranslation("common");
  const {isEnteredFromToShowFile } = useSelector((state: any) => state.UserReducer);

  const steps = [
    t("Register.firstStepLabel"),
    t("Register.secondStepLabel"),
    t("Register.thirdStepLabel"),
    t("Register.fourthStepLabel"),
  ];

  const [activeStep, setActiveStep] = useState<number>(0);
  const [phoneAndEmailError, setPhoneAndEmailError] = useState<boolean>(false);
  const [registerBankAccountTokenNum, setRegisterBankAccountTokenNum] = useState<string | null>();

  const renderCurrentStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <h1 className="visually-hidden">{t("Register.firstStepLabel")}</h1>
            <RegFirstStep
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              setPhoneAndEmailError={setPhoneAndEmailError}
              registerBankAccountTokenNum={setRegisterBankAccountTokenNum}
            />
          </>
        );
      case 1:
        return (
          <>
            <h1 className="visually-hidden">{t("Register.secondStepLabel")}</h1>
            {phoneAndEmailError ? (
              <BankAccountVerify
                setActiveStep={setActiveStep}
                activeStep={activeStep}
                registerBankAccountTokenNum={registerBankAccountTokenNum}
              />
            ) : (
              <RegSecondStep
                setActiveStep={setActiveStep}
                activeStep={activeStep}
              />
            )}
          </>
        );
      case 2:
        return (
          <>
            <h1 className="visually-hidden">{t("Register.thirdStepLabel")}</h1>
            <RegThirdStep
              setActiveStep={setActiveStep}
              activeStep={activeStep}
            />
          </>
        );
      case 3:
        return (
          <>
            <h1 className="visually-hidden">{t("Register.fourthStepLabel")}</h1>
            <RegFourthStep />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="register page">
      <div className="content">
      <div className="wrap-login-wrap-details">
        <div
          className="register-wrap-details"
          style={{
            maxHeight: `${activeStep === 2 ? "98%" : ""} ${
              activeStep === 3 ? "60%" : ""
            }`,
          }}
        >
          <Box sx={{ width: "100%" }}>
          <Stepper
              activeStep={activeStep}
              alternativeLabel
              connector={<ColorlibConnector />}
            >
              {steps.map((label) => (
                <Step key={label} sx={{ color: "#0250C1" }} color="#0250C1">
                  <StepLabel><span className="visually-hidden">{activeStep}שלב מספר:</span><span className="visually-hidden">מספר השלבים בתהליך</span>{label}</StepLabel>
                </Step>
              ))}
            </Stepper> 
          </Box>
          {renderCurrentStep()}
        </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
